import {
  Box,
  Button,
  Grid,
  Hidden,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material';
import { getProperties } from '../../../../utils/helpers';
import React, { useContext, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../utils/appContext';
import { searchReservation } from '../../../../utils/requests';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Dayjs } from 'dayjs';
import { DateRange, DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker';

const SearchForm = () => {
  const useStyles = makeStyles()((theme) => {
    return {
      bmTitle: {
        fontSize: 36,
        fontFamily: theme.typography.h1.fontFamily
      },
      labelTitle: {
        fontSize: 18,
        fontFamily: theme.typography.h1.fontFamily
      },
      ctaManagement: {
        fontSize: 16,
        fontFamily: theme.typography.h1.fontFamily
      },
      confirmBtn: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 0,
        padding: '20px 32px',
        boxShadow: '0 -3px 10px #00000029',
        '.MuiButton-root': {
          width: '100%',
          backgroundColor: 'black',
          color: 'white',
          borderRadius: theme.radius.formBorderRadius,
          fontSize: 20,
          borderColor: 'black',
          '&:hover': {
            backgroundColor: 'black',
            color: 'white',
            borderColor: 'black'
          }
        }
      }
    };
  });

  const { classes } = useStyles();
  const { t } = useTranslation();
  let history = useHistory();

  const appContext = useContext(AppContext);

  const [property, setProperty] = React.useState('');

  const handleChange = (event: SelectChangeEvent) => {
    setProperty((event.target.value as string) || appContext.website);
  };

  const [value, setValue] = useState<DateRange<Dayjs>>([null, null]);
  const [guestNum, setGuestNum] = useState<string>('');

  const editGuestNum = (event: any) => {
    setGuestNum(event.target.value);
  };

  const searchRes = (event: any) => {
    event.preventDefault();

    searchReservation({
      GuestArrival: value[0],
      GuestDeparture: value[1],
      property: appContext.website,
      GuestNum: guestNum,
      status: 'to_start'
    })
      .then(function (response) {
        history.push(
          `/booking-management/search?GuestArrival=${value[0]?.format(
            'DD.MM.YYYY'
          )}&GuestDeparture=${value[1]?.format('DD.MM.YYYY')}&GuestNum=${guestNum}&property=${
            appContext.website
          }`
        );
        localStorage.setItem('token_bookings_management', response.data.Authorization);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <Grid item xs={12} sm={7} md={8} lg={9}>
      <Grid container direction={'row'} justifyContent={'center'} alignItems={'center'}>
        <Grid item xs={12}>
          <Box textAlign={'center'}>
            <Typography variant={'h2'} component={'h2'} className={classes.bmTitle}>
              Ricerca la prenotazione
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={10} sm={12} md={12} lg={10}>
          <Box mt={5}>
            <form onSubmit={searchRes}>
              <Grid
                container
                direction={'row'}
                justifyContent={'flex-start'}
                alignItems={'center'}
                spacing={5}>
                <Grid item xs={12}>
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    localeText={{ start: 'Check-in', end: 'Check-out' }}>
                    <DateRangePicker
                      value={value}
                      onChange={(newValue) => {
                        setValue(newValue);
                      }}
                      inputFormat={'LL'}
                      disablePast={true}
                      disableMaskedInput={true}
                      renderInput={(startProps, endProps) => (
                        <Grid
                          container
                          direction={'row'}
                          justifyContent={'flex-start'}
                          alignItems={'center'}
                          spacing={5}>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant={'h6'}
                              component={'span'}
                              className={classes.labelTitle}>
                              Check-in
                            </Typography>
                            <Box pt={1}>
                              <TextField {...startProps} variant="filled" />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <Typography
                              variant={'h6'}
                              component={'span'}
                              className={classes.labelTitle}>
                              Check-out
                            </Typography>
                            <Box pt={1}>
                              <TextField {...endProps} variant="filled" />
                            </Box>
                          </Grid>
                        </Grid>
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Typography variant={'h6'} component={'span'} className={classes.labelTitle}>
                    N° prenotazione
                  </Typography>
                  <Box pt={1}>
                    <TextField
                      required
                      name={'GuestFirstname'}
                      label={t('N°prenotazione')}
                      variant="filled"
                      value={guestNum}
                      onChange={editGuestNum}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6}>
                  {appContext.website === 'HU' ||
                    (appContext.website === 'EV' && (
                      <>
                        <Typography
                          variant={'h6'}
                          component={'span'}
                          className={classes.labelTitle}>
                          Struttura
                        </Typography>
                        <br />
                        <Box pt={1}>
                          <Select
                            required
                            name={'Property'}
                            value={property}
                            sx={{ width: '100%', backgroundColor: 'white' }}
                            onChange={handleChange}>
                            {getProperties().map((a: any, index: number) => {
                              if (
                                (a.type === 'VI' || a.type === 'CIT') &&
                                !a.title.includes('TEST')
                              ) {
                                return (
                                  <MenuItem value={a.code}>
                                    {a.title}
                                    <br />
                                  </MenuItem>
                                );
                              }
                            })}
                          </Select>
                        </Box>
                      </>
                    ))}
                </Grid>

                <Hidden smDown>
                  <Grid item xs={6} mt={2}>
                    <Button
                      variant={'contained'}
                      color={'secondary'}
                      fullWidth
                      className={classes.ctaManagement}
                      type="submit">
                      Cerca
                    </Button>
                  </Grid>
                </Hidden>

                <Hidden smUp>
                  <Paper elevation={2} square className={classes.confirmBtn}>
                    <Button color="primary" variant="outlined" type="submit">
                      {t('Start_search')}
                    </Button>
                  </Paper>
                </Hidden>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SearchForm;
